import React from 'react';
import { isoToFlag } from './CountryTag.jsx';

export function MessageSourceCard({
  iso, country, count = 1, preview, emoji, onOpen, onClose, style = {},
}) {
  return (
    <div style={{
      width: 300,
      background: 'var(--surface-glass)',
      backdropFilter: 'var(--blur-strong)',
      border: '1px solid var(--border-brand)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-glass)',
      color: 'var(--text-on-dark)',
      overflow: 'hidden',
      ...style,
    }}>
      {/* header — flag + country + count + close */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '0.75rem',
        padding: 'var(--space-4)',
        background: 'linear-gradient(135deg, rgba(102,126,234,0.30) 0%, rgba(118,75,162,0.20) 100%)',
        borderBottom: '1px solid var(--border-brand)',
      }}>
        <span style={{ fontSize: '2rem', lineHeight: 1 }}>{isoToFlag(iso)}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 'var(--text-md)', fontWeight: 'var(--weight-bold)', color: '#fff' }}>{country}</div>
          <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-on-dark-muted)' }}>
            {count} message{count === 1 ? '' : 's'} from here
          </div>
        </div>
        {onClose && (
          <button onClick={onClose} aria-label="Close" style={{
            width: 26, height: 26, flexShrink: 0, borderRadius: '50%',
            background: 'rgba(255,107,107,0.18)', border: '1px solid rgba(255,107,107,0.3)',
            color: 'var(--danger-400)', cursor: 'pointer', fontSize: '1rem', lineHeight: 1,
          }}>×</button>
        )}
      </div>

      {/* body — anonymous sender + message preview */}
      {preview && (
        <div style={{ padding: 'var(--space-4)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <span style={{
              width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              background: 'linear-gradient(135deg,#9c27b0,#673ab7)', fontSize: '0.9rem',
            }}>{emoji || '🙂'}</span>
            <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-on-dark-muted)' }}>Anonymous</span>
          </div>
          <p style={{
            margin: 0, fontSize: 'var(--text-sm)', lineHeight: 'var(--leading-normal)',
            color: 'var(--text-on-dark)',
          }}>{preview}</p>
        </div>
      )}

      {/* footer — open chat */}
      {onOpen && (
        <div style={{ padding: '0 var(--space-4) var(--space-4)' }}>
          <button onClick={onOpen} style={{
            width: '100%', padding: '0.55rem', border: 'none', cursor: 'pointer',
            borderRadius: 'var(--radius-sm)', background: 'var(--brand-gradient)',
            color: '#fff', fontWeight: 'var(--weight-semibold)', fontSize: 'var(--text-sm)',
          }}>Open chat</button>
        </div>
      )}
    </div>
  );
}
